import React, { useEffect } from 'react'
import classes from './Contact.module.css';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Contact = (props) => {

    const { lang } = useParams();
    const { i18n } = useTranslation();
    useEffect(() => {
      i18n.changeLanguage(lang);
    }, [i18n, lang]);

  return (
    <main>
        <section className={classes.contact}>
            <div id="form" className={classes.contact__info}>
                <h3 className={classes.contact__heading}>
                    {props.onTranslate('contact__heading')}
                </h3>
                <p className={classes.contact__text}> 
                    {props.onTranslate('contact__text')}
                </p>
            </div>
        </section>
    </main>
  )
}

export default Contact;